/**
 * Verifies if a DNS CNAME record is valid by calling the backend API
 * @param accountId - The account ID
 * @param assetId - The asset ID
 * @returns Promise<{ valid: boolean; dnsProvider: string | null }> - Verification result and DNS provider
 */
export const verifyDnsRecord = async (
	accountId: string,
	assetId: string
): Promise<{ valid: boolean }> => {
	try {
		const { Assets } = await import('../../services/user/assets')
		const result = await Assets.verifyDnsRecord(accountId, assetId)
		return {
			valid: result.valid
		}
	} catch (error) {
		console.error('DNS verification error:', error)
		return {
			valid: false
		}
	}
}

